import React from "react";
import PropTypes from "prop-types";
import { isEmpty, map } from "lodash";

import { H4, ListItem, Text, Paragraph } from "components/core/Typography";
import { Checkmark, CircleSlash } from "components/core/Icons";
import { FacilityPageSection } from "components/facility/FacilityPageSection";
import formatUSD from "utils/formatUSD";

import "./FeaturesAndAmenitiesSection.scss";
import { Heading } from "components/storages/Common";

const ServiceItem = ({ hasAttribute, label }) => (
	<ListItem size="small">
		{hasAttribute ? <Checkmark /> : <CircleSlash />}
		<Text
			size="small"
			color={hasAttribute ? "gray" : "lightGray"}
			strikethrough={!hasAttribute}
		>
			{label}
		</Text>
	</ListItem>
);

ServiceItem.propTypes = {
	label: PropTypes.string,
	hasAttribute: PropTypes.bool
};

const ServiceList = ({ serviceTitle, items }) => (
	<div className="service-list">
		<Heading
			size="small"
			color="gray"
			content={serviceTitle}
			level="3"
		/>
		<ul>
			{map(
				items,
				(item) =>
					(!!item.showAlways || !!item.hasAttribute) && (
						<ServiceItem
							hasAttribute={item.hasAttribute}
							label={item.label}
							key={item.label}
						/>
					)
			)}
		</ul>
	</div>
);

ServiceList.propTypes = {
	serviceTitle: PropTypes.string,
	items: PropTypes.shape({
		label: PropTypes.string,
		hasAttribute: PropTypes.bool
	})
};

const FeaturesAndAmenitiesSection = ({ amenities, adminFee }) => {
	if (!adminFee || isEmpty(amenities)) return null;
	return (
		<FacilityPageSection
			title="Features & Amenities"
			isCollapsable
			className="features-section"
		>
			<div className="admin-fee">
				<Heading
					level="3"
					color="gray"
					size="small"
					content="Admin Fee"
				/>
				<Paragraph
					size="small"
					color="gray"
				>
					{formatUSD(adminFee, { showDecimal: true })}
				</Paragraph>
				<Paragraph
					size="small"
					color="gray"
				>
					This is a fee from the facility due when you move into a
					storage unit.
				</Paragraph>
			</div>
			<H4
				className="hide-for-desktop"
				last
				color="darkGray"
			>
				Storage Services
			</H4>
			{map(amenities, (group) => (
				<ServiceList
					serviceTitle={group.label}
					items={group.items}
					key={group.label}
				/>
			))}
		</FacilityPageSection>
	);
};

FeaturesAndAmenitiesSection.propTypes = {
	amenities: PropTypes.object,
	adminFee: PropTypes.number
};

export default FeaturesAndAmenitiesSection;
